// extracted by mini-css-extract-plugin
export default {"GoBack":"GoBack_GoBack__Y3b6y","Icon":"GoBack_Icon__UTKKn","Label":"GoBack_Label__vplh4"};